import { baseApiUrl } from '../constants';
import { chapters, currentChapter, userProgress } from '../stores';
import { authSvc, mappingSvc, progressSvc } from './';
class ChaptersService {
  constructor() {
    chapters.subscribe(ch => {
      this.chapters = ch;
      this.setInitialChapter();
    })
    userProgress.subscribe(up => {
      this.userProgress = up;
      this.setInitialChapter();
    });
  }

  initializeChapters() {
    authSvc.getChapters()
      .then(chaps => {
        const mappedChs = mappingSvc.mapChapters(chaps);
        chapters.set(mappedChs);
      });
  }

  setInitialChapter() {
    // manually allgemein
    if(this.userProgress?.chapters && !this.userProgress?.chapters?.allgemein) {
      this.userProgress.chapters.allgemein = {
        status: 'ready'
      };
    }

    if (!this.initExecuted && this.chapters && this.userProgress && !this.userProgress.chapters) {
      this.initExecuted = true;
      this.userProgress.chapters = {
        [this.chapters[0].slug]: {
          status: 'ready'
        }
      };

      // TODO: use settings to specify if one or all chapters are ready
      if (true) {
        this.chapters.forEach(ch => {
          if(typeof this.userProgress.chapters[ch.slug] == 'undefined') {
            this.userProgress.chapters[ch.slug] = {
              status: 'ready',
            };
          }
        });
      }

      // set all chapters ready for testuser
      if (this.userProgress.testuser) {
        console.debug('=== Testuser found === setting pages ready', JSON.stringify(this.userProgress.chapters));
        this.userProgress.closedPopups = {"page_login":true,"page_manager":true,"page_intro":true,"page_home":true,"page_platzreife":true};
        this.chapters.forEach(ch => {
          const numRules = ch.rules.length;
          let rulesRead = {};
          for (let i = 0; i < numRules; i++) {
            rulesRead[i] = true;
          }
          if(typeof this.userProgress.chapters[ch.slug] == 'undefined') {
            console.debug('=== Testuser found === setting ' + ch.slug + ' ready');
            this.userProgress.chapters[ch.slug] = {
              status: 'ready',
              videoPlayed: true,
              rulesRead: rulesRead
            };
          }
        })
        console.debug(this.userProgress);
      }
    }
  }

  getChapterStatus(slug) {
    // console.log('getChapterStatus', slug, this.userProgress?.chapters[slug]?.status, this.userProgress?.chapters[slug])
    return this.userProgress?.chapters && this.userProgress?.chapters[slug]?.status;
  }

  setChapterStatus(slug, status) {
    if (!this.userProgress.chapters[slug]) {
      this.userProgress.chapters[slug] = {};
    }
    this.userProgress.chapters[slug].status = status;
    progressSvc.setUserProgress(this.userProgress, slug);
  }

  setNextChapterReady(slug) {
    if(this.getChapterStatus(slug) !== 'success') {
      return;
    }
    let nextIndex;
    this.chapters.forEach((ch, cIdx) => {
      if (slug == ch.slug) {
        nextIndex = cIdx + 1;
      }
      if (nextIndex === cIdx && !this.getChapterStatus(ch.slug)) {
        this.setChapterStatus(ch.slug, 'ready');
      }
    });
  }
}

export const chaptersSvc = new ChaptersService();